import React from 'react'
import PropTypes from 'prop-types'
import createStyles from './styles'
import { css } from 'aphrodite'
import { Icon } from 'semantic-ui-react'

import { copyToClipboard } from '../helpers'

import { Text } from './Text'

export class PaymentDetails extends React.PureComponent {
  render() {
    const { address, memo } = this.props
    const ss = getStyles(this.props, this.context)

    return (
      <div>
        <div className={css(ss.tableContainer)}>
          <table cellPadding={8} className={css(ss.table)}>
            <tbody>
              {address && (
                <tr className={css(ss.tr)}>
                  <th className={css(ss.th)}>Address</th>
                  <td className={css(ss.td)}>
                    <input
                      readOnly
                      ref="address"
                      className={css(ss.input)}
                      value={address}
                    />
                  </td>
                  <td
                    className={css(ss.tdIcon)}
                    onClick={() => copyToClipboard(null, this.refs.address)}
                  >
                    <Icon name="copy" className={css(ss.copyIcon)} />
                  </td>
                </tr>
              )}

              {memo && (
                <tr className={css(ss.tr)}>
                  <th className={css(ss.th)}>Memo</th>
                  <td className={css(ss.td)}>
                    <input
                      readOnly
                      ref="memo"
                      className={css(ss.input)}
                      value={memo}
                    />
                  </td>
                  <td
                    className={css(ss.tdIcon)}
                    onClick={() => copyToClipboard(null, this.refs.memo)}
                  >
                    <Icon name="copy" className={css(ss.copyIcon)} />
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {memo && (
          <div dataTest="memo-warning" className={css(ss.warning)}>
            <Text>
              <b>IMPORTANT:</b> This transaction requires you to include a memo
              with your transaction. If you forget to include this, we cannot
              issue you your tokens
            </Text>
          </div>
        )}
      </div>
    )
  }
}

PaymentDetails.contextTypes = {
  theme: PropTypes.object,
}

const borderColor = 'rgba(34,36,38,.15)'
const errorColor = {
  background: 'rgba(242, 42, 15, 0.1)',
  border: 'rgb(242, 42, 15)',
}

const getStyles = createStyles(props => ({
  tableContainer: {
    borderRadius: 4,
    position: 'relative',
    boxShadow: `0 0 0px 1px inset ${borderColor}`,
    overflow: 'hidden',
    marginTop: 10,
  },
  table: {
    borderCollapse: 'collapse',
    borderRadius: 4,
    width: '100%',
  },
  tr: {
    padding: 8,
  },
  th: {
    border: `1px solid ${borderColor}`,
  },
  td: {
    border: `1px solid ${borderColor}`,
    textAlign: 'left',
    paddingLeft: 12,
    alignItems: 'center',
  },
  tdIcon: {
    border: `1px solid ${borderColor}`,
    ':hover': {
      background: '#eee',
      cursor: 'pointer',
    },
  },
  warning: {
    background: errorColor.background,
    border: `1px solid ${errorColor.border}`,
    borderRadius: 4,
    margin: '10px 0',
    padding: 12,
  },
  input: {
    border: 'none',
    width: '100%',
  },
}))



// WEBPACK FOOTER //
// ./src/components/PaymentDetails.js